import { render, staticRenderFns } from "./TextColorEditor.vue?vue&type=template&id=3895e24a&scoped=true"
import script from "./TextColorEditor.vue?vue&type=script&lang=js"
export * from "./TextColorEditor.vue?vue&type=script&lang=js"
import style0 from "./TextColorEditor.vue?vue&type=style&index=0&id=3895e24a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895e24a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3895e24a')) {
      api.createRecord('3895e24a', component.options)
    } else {
      api.reload('3895e24a', component.options)
    }
    module.hot.accept("./TextColorEditor.vue?vue&type=template&id=3895e24a&scoped=true", function () {
      api.rerender('3895e24a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/TextColorEditor.vue"
export default component.exports